import { determineUpsellModal } from '@/utils';
const defaultState = () => ({
  baseUpsellModal: false,
  catalogModal: false,
  catalogModalPageId: null,
  catalogModalState: null,
  disabledDashboards: [],
  profileModalShown: '',
  miraDrawerShown: false,
  showAssetTray: false,
  showBlueScreen: false,
  showMergeBanner: false,
  upsellModal: false,
  upsellModalSource: {},
  upsellPopout: false,
  connectionError: false,
});

const getters = {
  baseUpsellModalStatus: state => state.baseUpsellModal,
  catalogModalPageId: state => state.catalogModalPageId,
  catalogModalState: state => state.catalogModalState,
  catalogModalStatus: state => state.catalogModal,
  disabledDashboards: state => state.disabledDashboards,
  profileModalShown: state => state.profileModalShown,
  miraDrawerShown: state => state.miraDrawerShown,
  showAssetTray: state => state.showAssetTray,
  showBlueScreen: state => state.showBlueScreen,
  showMergeBanner: state => state.showMergeBanner,
  upsellModalSource: state => state.upsellModalSource,
  upsellModalStatus: state => state.upsellModal,
  upsellPopoutStatus: state => state.upsellPopout,
  connectionError: state => state.connectionError,
};

const mutations = {
  setProfileModalShown(state, value) {
    state.profileModalShown = value;
  },
  setMiraDrawerShown(state, value) {
    state.miraDrawerShown = value;
  },
  setShowAssetTray(state, value) {
    state.showAssetTray = value;
  },
  setBaseUpsellModal(state, value) {
    state.baseUpsellModal = value;
  },
  setShowBlueScreen(state, value) {
    state.showBlueScreen = value;
  },
  setCatalogModal(state, value) {
    state.catalogModal = value;
  },
  setCatalogModalPageId(state, pageId) {
    state.catalogModalPageId = pageId;
  },
  setCatalogModalState(state, activeSection) {
    state.catalogModalState = activeSection;
  },
  setMergeBanner(state, value) {
    state.showMergeBanner = value;
  },
  setUpsellModal(state, value) {
    state.upsellModal = value;
  },
  setUpsellModalSource(state, source) {
    state.upsellModalSource = source;
  },
  setUpsellPopout(state, value) {
    state.upsellPopout = value;
  },
  setDashboardState(state, value) {
    state.disabledDashboards = value || [];
  },
  setEnableDashboard(state, value) {
    const i = state.disabledDashboards.indexOf(value);
    if (i >= 0) {
      state.disabledDashboards.splice(i, 1);
    }
  },
  setDisableDashboard(state, value) {
    const i = state.disabledDashboards.indexOf(value);
    if (i < 0) {
      state.disabledDashboards.push(value);
    }
  },
  setConnectionError(state, value) {
    state.connectionError = value;
  },
  reset(state) {
    state.baseUpsellModal = false;
    state.catalogModal = false;
    state.catalogModalPageId = null;
    state.catalogModalState = null;
    state.disabledDashboards = [];
    state.profileModalShown = '';
    state.showAssetTray = false;
    state.showBlueScreen = false;
    state.showMergeBanner = false;
    state.upsellModal = false;
    state.upsellModalSource = {};
    state.upsellPopout = false;
    state.connectionError = false;
  },
};

const actions = {
  disableDashboard({ commit }, id) {
    commit('setDisableDashboard', id);
  },
  enableDashboard({ commit }, id) {
    commit('setEnableDashboard', id);
  },
  clearCatalogModalState({ commit }) {
    commit('setCatalogModalState', null);
  },
  setProfileModalShown({ commit }, value) {
    commit('setProfileModalShown', value);
  },
  setMiraDrawerShown({ commit }, value) {
    commit('setMiraDrawerShown', value);
  },
  toggleCatalogModal({ commit }, params) {
    // Will open with either addon or extension if active section is specified
    if (params.activeSection) {
      commit('setCatalogModalState', params.activeSection);
    }

    if (params.catalogPageId) {
      commit('setCatalogModalPageId', params.catalogPageId);
    }

    if (params.source) {
      commit('setUpsellModalSource', params.source);
    }

    commit('setCatalogModal', params.show);
  },
  forceBaseUpsellModal({ dispatch, commit, getters, rootGetters }, params) {
    commit('setBaseUpsellModal', params.show);
  },
  toggleUpsellModal({ dispatch, commit, getters, rootGetters }, params) {
    const { mutationName, catalogPageId } = determineUpsellModal(params, rootGetters);
    if (mutationName === 'setCatalogModal' && catalogPageId) {
      commit('setCatalogModalPageId', catalogPageId);
    }

    if (params.source) {
      commit('setUpsellModalSource', params.source);
    }

    commit(mutationName, params.show);
  },
  toggleUpsellPopout({ dispatch, commit, getters, rootGetters }, params) {
    commit('setUpsellPopout', params.show);
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
